module.exports = __webpack_public_path__ + "static/media/floor_floating_universal.c9f98100.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_floating_universal.png
 ** module id = 954
 ** module chunks = 0
 **/